import React from 'react';
import PropTypes from 'prop-types';

import Header from '../../blocks/Header';
import Usps from '../../blocks/Usps';
import ProductsInfo from '../../blocks/ProductsInfo';
import ContactForm from '../../blocks/ContactForm';
import Footer from '../../blocks/Footer';
import scrollToTopOrHash from '../../utils/helpers/scrollToTopOrHash';
import { sendPageView } from '../../utils/helpers/ga';

import networkImage from './assets/network.jpg';

class Hosting extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      scrollToTopOrHash();
      window.document.title = 'Hosting hos oss - ScandGate IT-support';
      sendPageView(this.props.location.pathname);
    }
  }

  render() {
    return (
      <div>
        <Header />

        <Usps
          dark
          background={networkImage}
          headline="Hosting hos ScandGate"
          content="Ingår alltid i vårt hostingpaket:"
          usps={[
            'Webbmail',
            'DNS-hantering',
            'Support via telefon & e-post',
          ]}
        />

        <ProductsInfo
          headline="Hostingpaket hos ScandGate"
          disclaimer={
              <em>
                Samtliga priser är exkl moms och betalas årsvis.<br />
                Ovan anges maxvärden oberoende av specifikt behov. Löpande support
                (uppdateringar/reparationer) av webbplatsen ingår ej, för detta krävs
                supportavtal (<a href="/webbproduktion#support">läs mer här</a>).<br /><br />
                * = Inkluderar ej produktion av webbplats
              </em>}
          productLeft={{
            name: 'Lilla',
            price: 49,
            tagline: 'För små företag med begränsad aktivitet',
            usps: [
              '5 subdomäner',
              '1 MySQL-databas',
              'E-postsupport',
            ],
            infoListItems: [
              { item: '1', description: 'GB diskutrymme' },
              { item: '25', description: 'GB trafik / mån' },
              { item: '5', description: 'E-postkonton' },
            ],
           }}
          productCenter={{
            name: 'Baspaketet',
            price: 95,
            tagline: 'Vårt baspaket täcker de flesta behov',
            usps: [
              '10 subdomäner',
              '2 MySQL-databaser',
              'Telefonsupport',
            ],
            infoListItems: [
              { item: '10', description: 'GB diskutrymme' },
              { item: '100', description: 'GB trafik / mån' },
              { item: '20', description: 'E-postkonton' },
            ],
          }}
          productRight={{
            name: 'Stora',
            price: 149,
            tagline: 'För medelstora företag med normal aktivitet',
            usps: [
              'Obegr. antal subdomäner',
              '5 MySQL-databaser',
              'Telefonsupport',
            ],
            infoListItems: [
              { item: '10', description: 'GB diskutrymme' },
              { item: '100', description: 'GB trafik / mån' },
              { item: '20', description: 'E-postkonton' },
            ],
          }}
        />

        <ContactForm
          darker
          headline="Beställ hosting hos ScandGate"
          hostingPackages={{
           // small: 'Lilla (49 :- / mån)',
           // medium: 'Mellan (99 :- / mån)',
            medium: 'Baspaket (95 :- / mån)',
          //  large: 'Stora (149 :- / mån)',
          }}
          subjectSelected="orderHosting"
          content={<p>Vi återkommer med betalningsuppgifter.</p>}
          ctaText="Beställ"
        />

        <Footer />
      </div>
    );
  }
}

Hosting.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Hosting;



// WEBPACK FOOTER //
// ./pages/Hosting/index.js